import _ from "lodash"
import Highcharts from "highcharts"
import { responsiveCSSStyle } from "./styles"
import colors from "./styleColors"

/**
 * Apply formatting function to values.
 *
 * @returns {string}
 */
function formatYAxisNumber() {
  return `${Highcharts.numberFormat(this.value, 0)} €`
}

function applyYAxisPlugin(yAxis) {
  _.set(yAxis, "labels.style", responsiveCSSStyle())
  _.set(yAxis, "labels.formatter", formatYAxisNumber)
  _.set(yAxis, "gridLineColor", colors.axisLineColor)
  _.set(yAxis, "gridLineWidth", 1)
}

/**
 * Custom yAxis
 * @param chartOpts
 * @returns {*}
 */
export default function montaigneYAxisPlugin(chartOpts) {
  if (!chartOpts.yAxis) {
    return chartOpts
  }

  if (_.isArray(chartOpts.yAxis)) {
    chartOpts.yAxis.forEach(applyYAxisPlugin)
    return chartOpts
  }
  // simple axis apply
  applyYAxisPlugin(chartOpts.yAxis)
  return chartOpts
}
